var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import CompanyDetails from '@/modules/search/components/CompanyDetails.vue';
import CompanyDetailIframeModal from '@/components/CompanyDetailIframeModal.vue';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { getSearchDrawerWidth, hasAtlasV4 } from '@/shared/utils/helpers';
import { SearchStatus } from '@/overmind/search/state';
import { connect } from '@/overmind';
import { isEmpty } from 'lodash';
let CompanyDetailContainer = class CompanyDetailContainer extends Vue {
    constructor() {
        super(...arguments);
        this.currentCompany = {};
        this.loadingDrawer = false;
        /**
         * Inicia como true: o SearchBody só monta este container quando já existe
         * uma empresa selecionada, então o painel pode abrir de imediato.
         */
        this.modalOpen = true;
    }
    get hasV4() {
        const stateUser = this.currentUser;
        // Sem optional chaining: o ts-loader/webpack desta config nao parseia `?.`
        const auth = Vue.auth;
        const authUser = auth && typeof auth.user === 'function' ? auth.user() : null;
        const user = stateUser && Object.keys(stateUser).length > 0 ? stateUser : authUser;
        return hasAtlasV4(user);
    }
    created() {
        // @ts-ignore TS2349: property inexistent
        this.actions.setAdvancedDataState(SearchStatus.NOT_RECEIVED);
        // @ts-ignore TS2349: property inexistent
        if (this.showHistory) {
            // @ts-ignore TS2349: property inexistent
            this.actions.setShowHistory(false);
        }
    }
    mounted() {
        this.$gtag.pageview({ page_path: this.$route.path });
    }
    getWidth() {
        return getSearchDrawerWidth();
    }
    hasDecisorsData() {
        // @ts-ignore
        return !isEmpty(this.currentCompany.availableInformation.decision_makers);
    }
    hasAdditionalData() {
        return !isEmpty(
        // @ts-ignore
        this.currentCompany.availableInformation.additional_information);
    }
    async setStateFiltersInLocalStorage() {
        // @ts-ignore
        //localStorage.setItem('stateFilters', JSON.stringify(this.filters))
        await this.filtersActions.setStateFiltersInStorage();
    }
    async unsetStateFiltersInLocalStorage() {
        // @ts-ignore
        await this.filtersActions.unsetStateFiltersInStorage();
    }
    cleanFilters() {
        // @ts-ignore
        this.filtersActions.resetStateFilters('');
    }
    async redirectSearch() {
        // @ts-ignore
        const id = await this.actions.searches.createSearchbyDrawer({});
        // @ts-ignore
        window.open(`${window.location.origin}/search/${id}`, '_blank');
    }
    closeCompanyDrawer() {
        this.modalOpen = false;
        // @ts-ignore TS2349: property inexistent
        this.companiesActions.setHyperbolicData({ nodes: [], links: [] });
        // @ts-ignore TS2349: property inexistent
        this.actions.setShowCompany(false);
        // @ts-ignore TS2349: property inexistent
        this.actions.setAdditionalDataState(SearchStatus.NOT_RECEIVED);
        // @ts-ignore TS2349: property inexistent
        this.actions.setNoCreditsToGetCompany(false);
        // @ts-ignore TS2349: property inexistent
        this.actions.resetCurrentCompany();
    }
    async openModalExport() {
        // @ts-ignore TS2349: property inexistent
        await this.actions.getCredits();
        // @ts-ignore TS2349: property inexistent
        this.actions.exportations.modalExportOnlyCompany();
    }
    getCompanyCnpjsNextPage(page) {
        // @ts-ignore
        this.companiesActions.getCompanyCnpjs({
            // @ts-ignore
            cnpj: this.currentCompanyCNPJ,
            page,
        });
    }
};
__decorate([
    Prop({ default: () => { } })
], CompanyDetailContainer.prototype, "hyperbolicData", void 0);
CompanyDetailContainer = __decorate([
    Component(connect(({ state: { search: state, filters: stateFilters, companies: stateCompanies, users: stateUsers, }, actions, }) => ({
        showCompany: state.showCompany,
        currentSearchId: state.currentSearchId,
        companies: state.companies,
        filters: stateFilters,
        currentCompany: stateCompanies.currentCompany,
        currentCompanyCNPJ: state.currentCompanyCNPJ,
        actions: actions.search,
        additionalDataState: state.additionalDataState,
        searchStatus: state.createSearchState,
        showHistory: state.showHistory,
        noCreditsToGetCompany: state.noCreditsToGetCompany,
        companiesActions: actions.companies,
        filtersActions: actions.filters,
        companyStatus: state.companyStatus,
        companiesState: stateCompanies,
        isConsultHistory: state.isConsultHistory,
        actionsInfosets: actions.infosets,
        currentUser: stateUsers.currentUser,
    }), { components: { CompanyDetailIframeModal, CompanyDetails } }))
], CompanyDetailContainer);
export default CompanyDetailContainer;
